<div class="filter-container">
  <div class="filter-label">{{title}}: </div>
  <div class="filter-select">
    <mat-select #valueChoice (valueChange)="emitFilterEvent(valueChoice.value)" [value]="currentValue" data-type="filter-box">
      <mat-option *ngFor="let choiceKey of filterOptions" [value]="choiceKey" data-type="filter-option">{{filterMapValues.get(choiceKey)}}</mat-option>
    </mat-select>
  </div>
</div>

